import { render, staticRenderFns } from "./IconArchive.vue?vue&type=template&id=c8542ce8"
import script from "./IconArchive.vue?vue&type=script&lang=js"
export * from "./IconArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports